// @ts-check
import React, { forwardRef } from 'react';

/**
 * TableContainer.
 */

/** @typedef {React.HTMLAttributes<HTMLDivElement>} TableContainerProps */

/** @type { React.ForwardRefExoticComponent<TableContainerProps & React.RefAttributes<HTMLDivElement>> } */
export const TableContainer = forwardRef(
  (props, ref) => {
    const { className = '', ...rest } = props;
    return (
      <div className={`flex flex-col ${className}`}>
        <div className="sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 py-2 -my-2 overflow-x-auto">
          <div
            className="sm:rounded-lg inline-block min-w-full overflow-hidden align-middle border border-gray-200 shadow-md"
            ref={ref}
            {...rest}
          />
        </div>
      </div>
    );
  }
);

/**
 * Table.
 */

/** @typedef {React.HTMLAttributes<HTMLTableElement>} TableProps; */

/** @type { React.ForwardRefExoticComponent<TableProps & React.RefAttributes<HTMLDivElement>> } */
export const Table = forwardRef((props, ref) => {
  const { className = '', ...rest } = props;
  return (
    <table className={`_Table min-w-full ${className}`} ref={ref} {...rest} />
  );
});

/**
 * TH.
 */

/** @typedef {React.HTMLAttributes<HTMLTableHeaderCellElement>} THProps; */

/** @type { React.ForwardRefExoticComponent<THProps & React.RefAttributes<HTMLTableHeaderCellElement>> } */
export const TH = forwardRef(
  (props, ref) => {
    const { className = '', ...rest } = props;
    return (
      <th
        className={`px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-semibold text-gray-500 uppercase tracking-wider truncate ${className}`}
        ref={ref}
        {...rest}
      />
    );
  }
);

/**
 * TD.
 */

/** @typedef {{
  wrap?: boolean;
} & React.HTMLAttributes<HTMLTableCellElement>} TDProps */

/** @type { React.ForwardRefExoticComponent<TDProps & React.RefAttributes<HTMLTableCellElement>> } */
export const TD = forwardRef((props, ref) => {
  const { className = '', wrap = false, ...rest } = props;
  return (
    <td
      className={`px-6 py-4 ${wrap ? "" : "whitespace-no-wrap"} border-t border-gray-200 text-sm leading-5 ${className}`}
      ref={ref}
      {...rest}
    />
  );
});
